export const waitingForFccaAutofill = "waiting-for-fcca-autofill";

const { REACT_APP_FMP_EUROSPORT_PLAYER_URL, REACT_APP_FMP_EUROSPORT_PLAYER_MOBILE_URL, REACT_APP_FMP_GOLF_TV_URL } = process.env
export const trustedUrls = [REACT_APP_FMP_EUROSPORT_PLAYER_URL, REACT_APP_FMP_EUROSPORT_PLAYER_MOBILE_URL, REACT_APP_FMP_GOLF_TV_URL];

